export const ENABLED_FREQUENCY_CAPPING = 'enabled-frequency-capping';
export const ALLOWLIST_FREQUENCY_CAPPING = 'allowlist-frequency-capping';
export const USE_V2_FREQUENCY_CAPPING = 'use-v2-frequency-capping';

export const ENABLED_TARGETING_ATTENTION = 'enabled-targeting-attention';
export const ALLOWLIST_TARGETING_ATTENTION = 'allowlist-targeting-attention';

export const ENABLED_CONTEXTUAL_SEGMENTS_V3 = 'contextual-segments-v3';
export const ALLOWLIST_CONTEXTUAL_SEGMENTS_V3 = 'allowlist-contextual-segments-v3';

export const dealPromptFlags = {
  DEAL_PROMPT_RELEVANCE_SCORE_FLOOR: 'deal-prompt-relevance-score-floor',
  DEAL_PROMPT_PERFORMANCE_SCORE_FLOOR: 'deal-prompt-performance-score-floor',
  DEAL_PROMPT_SCALE_SCORE_FLOOR: 'deal-prompt-scale-score-floor',
  DEAL_PROMPT_DOMAINS_NUMBER_OF_RESULTS: 'deal-prompt-domains-number-of-results',
  DEAL_PROMPT_BUNDLES_NUMBER_OF_RESULTS: 'deal-prompt-bundles-number-of-results',
  DEAL_PROMPT_MARKET_THRESHOLD: 'deal-prompt-market-threshold',
  DEAL_PROMPT_DOMAINS_IMPRESSIONS_THRESHOLD: 'deal-prompt-domains-impressions-filter',
  DEAL_PROMPT_BUNDLES_IMPRESSIONS_THRESHOLD: 'deal-prompt-bundles-impressions-filter',
  DEAL_PROMPT_DOMAINS_CPR_MARKET_REQUESTS_THRESHOLD: 'deal-prompt-domains-cpr-market-requests-filter',
  DEAL_PROMPT_BUNDLES_CPR_MARKET_REQUESTS_THRESHOLD: 'deal-prompt-bundles-cpr-market-requests-filter',
  DEAL_PROMPT_SINGLE_TILE_APP_VERSION_ALLOWLIST: 'allowlist-deal-prompt-result-version',
  DEAL_PROMPT_RESULTS_UI_V2: 'deal-prompt-results-ui-v2',
} as const;

export const ORGANIZATION_UIDS_ALLOWED_TO_SEE_AQUA_DSP = 'organisation-uids-allowed-to-see-aqua-dsp';

export const ENABLED_APP_INVENTORY = 'enabled-app-inventory';
export const ALLOWLIST_APP_INVENTORY = 'allowlist-app-inventory';

export const ENABLED_AQUA = 'enabled-aqua';
export const ALLOWLIST_AQUA_CROSS_APP_NAV = 'allowlist-aqua-cross-app-nav';

export const ALLOWLIST_DATA_VIZ_EARLY_ACCESS = 'allowlist-data-viz-early-access';

export const ENABLED_BUYER_AND_SEAT_EDIT = 'enabled-buyer-and-seat-edit';
export const ALLOWLIST_BUYER_AND_SEAT_EDIT = 'allowlist-buyer-and-seat-edit';

export const ALLOWLIST_DEAL_PACING = 'allowlist-deal-pacing';

export const ENABLED_DEAL_SENSITIVE_CATEGORIES = 'enabled-deal-sensitive-categories';

export const DEAL_INSIGHTS_V2_ACCESS = 'deal-insights-v2-access';

export const ALLOWLIST_HOUSEHOLD_INSIGHTS = 'allowlist-household-insights';

export const ENABLED_DESIGN_SYSTEM_COMPONENTS = 'ui-design-system';
